<div class="login-page">
  <aside class="login-page__brand">
    <div class="login-page__brand-header">
      <img class="login-page__brand-logo" src="/assets/img/TestSolutions_Logo_white.png" alt="TestSolutions" />
      <span class="login-page__brand-divider" aria-hidden="true"></span>
      <span class="login-page__brand-name">
        <span>test</span>
        <strong class="login-page__brand-name-strong">OFFICE</strong>
      </span>
    </div>

    <div class="login-page__brand-body">
      <h2 class="login-page__brand-tagline">{{ 'login.brandTagline' | translate }}</h2>
      <p class="login-page__brand-subline">{{ 'login.brandSubline' | translate }}</p>

      <div class="login-page__status-preview" aria-hidden="true">
        <div class="login-page__status-pill login-page__status-pill--passed">
          <span class="login-page__status-dot"></span>
          <span class="login-page__status-bar"></span>
          <span class="login-page__status-label">PASSED</span>
        </div>
        <div class="login-page__status-pill login-page__status-pill--failed">
          <span class="login-page__status-dot"></span>
          <span class="login-page__status-bar"></span>
          <span class="login-page__status-label">FAILED</span>
        </div>
        <div class="login-page__status-pill login-page__status-pill--running">
          <span class="login-page__status-dot"></span>
          <span class="login-page__status-bar"></span>
          <span class="login-page__status-label">RUNNING</span>
        </div>
      </div>
    </div>

    <p class="login-page__brand-footer">{{ 'login.brandFooter' | translate }}</p>
  </aside>

  <main class="login-page__form-panel">
    <div class="login-page__locale">
      <button
        class="login-page__locale-btn"
        mat-icon-button
        type="button"
        [matMenuTriggerFor]="localeMenu"
        [attr.aria-label]="'languageMenu.ariaLabel' | translate"
      >
        <mat-icon aria-hidden="true">language</mat-icon>
        <span class="login-page__locale-code">{{ selectedLocale().toUpperCase() }}</span>
      </button>
      <mat-menu #localeMenu="matMenu">
        <button mat-menu-item type="button" (click)="selectLocale('de')">
          {{ 'languageMenu.german' | translate }}
        </button>
        <button mat-menu-item type="button" (click)="selectLocale('en')">
          {{ 'languageMenu.english' | translate }}
        </button>
      </mat-menu>
    </div>

    <div class="login-page__form-inner">
      <h1 class="login-page__headline">{{ 'login.headline' | translate }}</h1>
      <p class="login-page__subline">{{ 'login.subline' | translate }}</p>

      @if (authState.authError() === 'forbidden') {
        <div class="login-page__alert" role="alert">
          <mat-icon aria-hidden="true">block</mat-icon>
          <span>{{ 'login.forbiddenError' | translate }}</span>
        </div>
      }
      @if (authState.authError() === 'unauthorized') {
        <div class="login-page__alert" role="alert">
          <mat-icon aria-hidden="true">lock</mat-icon>
          <span>{{ 'login.unauthorizedError' | translate }}</span>
        </div>
      }

      <label class="login-page__email-label" for="login-email">{{ 'login.emailLabel' | translate }}</label>
      <input
        id="login-email"
        class="login-page__email-input"
        type="email"
        autocomplete="email"
        [maxlength]="fieldLengths.EMAIL_MAX"
        [placeholder]="'login.emailPlaceholder' | translate"
        [formControl]="emailControl"
        (keydown.enter)="requestCode()"
      />

      @if (requestError()) {
        <div class="login-page__request-error" role="alert">{{ 'login.requestError' | translate }}</div>
      }

      <button
        class="login-page__send-code-btn"
        type="button"
        [disabled]="emailControl.invalid || requesting()"
        (click)="requestCode()"
      >
        {{ 'login.sendCodeButton' | translate }}
      </button>

      <p class="login-page__no-password-hint">{{ 'login.noPasswordHint' | translate }}</p>

      <div class="login-page__divider">
        <span class="login-page__divider-line"></span>
        <span class="login-page__divider-label">{{ 'login.orDivider' | translate }}</span>
        <span class="login-page__divider-line"></span>
      </div>

      <button class="login-page__ms-btn" type="button" (click)="loginWithMicrosoft()">
        <svg
          class="login-page__ms-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 23 23"
          aria-hidden="true"
        >
          <rect width="10" height="10" fill="#f25022" />
          <rect x="12" width="10" height="10" fill="#7fba00" />
          <rect y="12" width="10" height="10" fill="#00a4ef" />
          <rect x="12" y="12" width="10" height="10" fill="#ffb900" />
        </svg>
        <span>{{ 'login.microsoftButton' | translate }}</span>
      </button>

      <p class="login-page__support">
        {{ 'login.supportPrompt' | translate }}
        <a class="login-page__support-link" [attr.href]="'mailto:' + supportEmail">
          {{ 'login.itSupport' | translate }}
        </a>
      </p>
    </div>
  </main>

  @if (step() === 'otp') {
    <app-otp-dialog
      [email]="targetEmail()"
      [submitting]="verifying()"
      [errorMessage]="otpError()"
      (verify)="onVerify($event)"
      (resend)="onResend()"
      (changeEmail)="onChangeEmail()"
      (dismiss)="onChangeEmail()"
    />
  }
</div>
